import { useEffect } from 'react'

import { usePostHog } from 'posthog-js/react'
import { posthogManager } from 'utils/posthog/manager'

export function PosthogManagerProvider({
  children
}: {
  children: React.ReactNode
}) {
  const posthog = usePostHog()
  useEffect(() => {
    if (!posthog || posthogManager.isInitialized()) return

    posthogManager.initialize(posthog)
    // eslint-disable-next-line no-console
    console.log('PostHog manager initialized')
  }, [posthog])

  return <>{children}</>
}
